import { render, staticRenderFns } from "./AIChatWidgetPdpParallelGridLegacy.vue?vue&type=template&id=40bbbafa&scoped=true"
import script from "./AIChatWidgetPdpParallelGridLegacy.vue?vue&type=script&lang=js"
export * from "./AIChatWidgetPdpParallelGridLegacy.vue?vue&type=script&lang=js"
import style0 from "./AIChatWidgetPdpParallelGridLegacy.vue?vue&type=style&index=0&id=40bbbafa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bbbafa",
  null
  
)

export default component.exports